'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconDesktop, iconDesktopTag } from '@ni/nimble-components/dist/esm/icons/desktop';
import { wrap } from '../../utilities/react-wrapper';

export type { IconDesktop };
export { iconDesktopTag };
export const NimbleIconDesktop = wrap(IconDesktop);